import React from 'react';
import { withRouter } from 'react-router-dom';

import Logo from '../Common/components/Logo';
import { Link } from 'react-router-dom';
import images from '../Common/Images';
import localStorage from '../Common/LocalStorage';
import { UserRole } from '../Common/UserRole';
import { Api } from '../Common/rest-api/api-exports';
import { StaticRoutePaths } from '../Common/ClientRoutes';

import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';

let strings = new LocalizedStrings(translations);

class Navigation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            role: '',
            username: '',
            company: '',
            pharmacy: '',
            language: localStorage.getFromStorage('lang'),
            active: false
        };
        strings.setLanguage(localStorage.getFromStorage('lang'));
    }

    logoutHandler = e => {
        e.preventDefault();
        localStorage.removeUsername('username');
        localStorage.removeToken('token');
        localStorage.removeToken('refresh_token');
        localStorage.removeUsernameRole();
        localStorage.removeFromStorage('expiration_time');
        localStorage.removeFromStorage('loginTime');
        localStorage.removeFromStorage('userDetails');
        this.props.history.push(StaticRoutePaths.LOGIN);
    };

    handleChangeLanguage = lang => {
        localStorage.saveInStorage('lang', lang);
        window.location.reload();
    };

    openDropdownLanguage = () => {
            this.setState({ active: true });
    };

    componentWillMount() {
        Api.Users.details()
            .then(response => {
                this.setState({
                    role: response.body.role,
                    username: response.body.names,
                    company: response.body.company,
                    pharmacy: response.body.pharmacy
                });
            })
            .catch(() =>
                this.setState({
                    role: '',
                    username: '',
                    company: '',
                    pharmacy: ''
                })
            );
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = e => {
        if (this.node.contains(e.target)) {
            this.openDropdownLanguage();
        } else {
            this.setState({ active: false });
        }
    };

    generateLinks = () => {
        switch (this.state.role) {
            case UserRole.STORE_OWNER:
                return (
                    <li>
                        <Link to={StaticRoutePaths.INFO_COMPANY}>{strings.Company.toUpperCase()}</Link>
                    </li>
                );

            case UserRole.PHARMACY_MANAGER:
                return (
                    <li>
                        <Link to={StaticRoutePaths.PHARMACY_DETAILS + '/' + this.state.pharmacy.id}>{strings.Pharmacy.toUpperCase()}</Link>
                    </li>
                );

            default:
                return null;
        }
    };

    render() {
        return (
            <header className="qf-header">
                <div className="qf-navbar">
                    <div className="container h-100">
                        <div className="row h-100 align-items-center">
                            <div className="col">
                                <Link to={StaticRoutePaths.HOME}>
                                    <Logo url={images.NAV_LOGO} />
                                </Link>
                            </div>
                            <div className="col text-right">
                                <ul className="qf-navigation mb-0">
                                    <li>
                                        <Link to="#">
                                            <i className="fa fa-search" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={StaticRoutePaths.INFO_USER}>{this.state.username.toUpperCase()}</Link>
                                    </li>
                                    {this.generateLinks()}
                                    <li>
                                        <Link to="#" onClick={this.logoutHandler}>
                                            {strings.logout.toUpperCase()}
                                        </Link>
                                    </li>
                                    <li className="qf-menu-language">
                                        <div className="text-uppercase" onClick={this.openDropdownLanguage}>
                                            {this.state.language}
                                        </div>
                                        <div
                                            className={this.state.active ? `qf-language-dropdown qf-show` : `qf-language-dropdown qf-hide`}
                                            onClick={this.handleClick}
                                            ref={node => (this.node = node)}
                                        >
                                            <div onClick={() => this.handleChangeLanguage('en')}>EN</div>
                                            <div onClick={() => this.handleChangeLanguage('de')}>DE</div>
                                            <div onClick={() => this.handleChangeLanguage('fr')}>FR</div>
                                            {/* <div onClick={() => this.handleChangeLanguage('it')}>IT</div> */}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default withRouter(Navigation);



// WEBPACK FOOTER //
// ./src/customModules/Navigation/component-navigation.js